const MESSAGES = {
  sessaoExpirada: 'Sua sessão expirou. Por favor realize login novamente.',
  mostrarLinhas: 'Mostrar Linhas:',
};

export default MESSAGES;
